// RxJS
// NGRX
import { select, Store } from '@ngrx/store';

// State
import { AppState } from '../../../core/reducers';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import {
  selectUserfilesInStore,
  selectUserfilesPageLoading,
  selectUserfilesShowInitWaitingMessage,
} from '../_selectors/userfile.selectors';

export class UserfilesDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectUserfilesPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectUserfilesShowInitWaitingMessage)
    );

    this.store
      .pipe(select(selectUserfilesInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
